import { jsx as _jsx } from "react/jsx-runtime";
import { GalleryTitleContainer } from './styles/gallery-title.styled';
export const GalleryTitle = ({ caption }) => (_jsx(GalleryTitleContainer, { className: "PONCHO-gallery__title", children: caption }));
